module.exports = __webpack_public_path__ + "img/ball2_xb.7e4e0d45.png";